import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "fee_list"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "nav_top" };
const _hoisted_6 = { class: "d_navi" };
const _hoisted_7 = { class: "year" };
const _hoisted_8 = { class: "fee_box" };
const _hoisted_9 = { class: "t_base" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "text-end" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { class: "nav_under" };
const _hoisted_15 = { class: "d_navi" };
const _hoisted_16 = { class: "year" };
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
export default /*@__PURE__*/ _defineComponent({
    __name: 'payment_list',
    props: {
        common: {},
        payment_histories: {},
        year: {}
    },
    setup(__props) {
        const props = __props;
        const goPayment = (step) => {
            const year = Number.parseInt(props.year);
            if (year === 1 && step === -1)
                return;
            if (Number.isNaN(year))
                return;
            Inertia.get(route('payment_history.index'), { year: year + step });
        };
        //check the year is valid
        const validYear = Number.parseInt(props.year) && Number.parseInt(props.year) > 0;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[10] || (_cache[10] = _createElementVNode("h2", null, "支払履歴", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("ul", _hoisted_6, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goPayment(-1)), ["prevent"]))
                                            }, _cache[4] || (_cache[4] = [
                                                _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
                                            ]))
                                        ]),
                                        _createElementVNode("li", _hoisted_7, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (goPayment(1)), ["prevent"]))
                                            }, _cache[5] || (_cache[5] = [
                                                _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
                                            ]))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("table", _hoisted_9, [
                                        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "日付"),
                                                _createElementVNode("th", null, "区分"),
                                                _createElementVNode("th", null, "内訳"),
                                                _createElementVNode("th", { class: "text-end" }, "金額（税込）")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.payment_histories, (history) => {
                                                var _a;
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                    _createElementVNode("td", null, _toDisplayString(history.date), 1),
                                                    _createElementVNode("td", null, _toDisplayString(history.category), 1),
                                                    (history.question_id)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                                            _createVNode(_unref(Link), {
                                                                href: `/question/${history.question_id}`
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(history.subject), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["href"])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(history.subject), 1)),
                                                    _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(Formatter).formatAmount((_a = history.amount) !== null && _a !== void 0 ? _a : null)), 1)
                                                ]));
                                            }), 256)),
                                            (props.payment_histories.length <= 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _cache[6] || (_cache[6] = [
                                                    _createElementVNode("td", { colspan: "100%" }, " 支払履歴の結果はありません。 ", -1)
                                                ])))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("ul", _hoisted_15, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (goPayment(-1)), ["prevent"]))
                                            }, _cache[8] || (_cache[8] = [
                                                _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
                                            ]))
                                        ]),
                                        _createElementVNode("li", _hoisted_16, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (goPayment(1)), ["prevent"]))
                                            }, _cache[9] || (_cache[9] = [
                                                _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
                                            ]))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
